import axiosInstance from "../utils/authUtils";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class MpdService {

  static getDoc(item) {
  
      let api = '';
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.getDocument}?id=${item?.id}`
      } else{
      api = `${API_BASE_URL}${API_PATHS.getDocument}?limit=${item?.limit}&page=${item?.page}`;
      }
      return axiosInstance
          .get(api)
          
  }

  
static addDoc(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addDocument}`;
    return axiosInstance
        .post(api,item)
        
}
static editDoc(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editDocument}`;
    return axiosInstance
        .put(api,item)
        
}
static deleteDoc(item) {
  
    let api = '';
    if(item?.id){
        api = `${API_BASE_URL}${API_PATHS.deleteDocument}?id=${item?.id}`;
    }
    
    return axiosInstance
        .delete(api)
        
}

  static getGeneralInfo(item) {
  
      let api = '';
      
         api= `${API_BASE_URL}${API_PATHS.getGeneralInfo}`;
      
      return axiosInstance
          .get(api)
          
  }

  static editGeneralInfo(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editGeneralInfo}`;
    return axiosInstance
        .put(api,item)
        
}


  static getStaff(item) {
  
      let api = '';
      
         api= `${API_BASE_URL}${API_PATHS.getStaff}`;
      
      return axiosInstance
          .get(api)
          
  }

  static editStaff(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editStaff}`;
    return axiosInstance
        .put(api,item)
        
}


  static getInfrastructure(item) {
  
      let api = '';
      
         api= `${API_BASE_URL}${API_PATHS.getInfrastructure}`;
      
      return axiosInstance
          .get(api)
          
  }

  static editInfrastructure(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editInfrastructure}`;
    return axiosInstance
        .put(api,item)
        
}


  static getAcademics(item) {
  
      let api = '';
      
         api= `${API_BASE_URL}${API_PATHS.getAcademics}`;
      
      return axiosInstance
          .get(api)
          
  }

  static editAcademics(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editAcademics}`;
    return axiosInstance
        .put(api,item)
        
}


  
}

export default MpdService;